<template>
  <!-- <footer class="footer">
  	<p>© 2015 - {{ new Date().getFullYear() }} All Rights Reserved. Pepipost is a product of Netcore Solutions.<a href="https://pepipost.com/legal-security?utm_source=Tutorials&utm_medium=Tutorials&utm_campaign=Tutorials"> Legal and Security</a></p>
  </footer> -->
  <div>
  	<footer class="site-footer main-footer-wrap">
			<div class="footer-content">
				<div class="container acheivement-wrapper">
					<div class="reviews-content-list">
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Top 5 Email Marketing Platform - Gartner Voice of The Customer Report
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/08/gartner.svg" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Recognized as a Leader in the G2 Spring 2023 Reports
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/11/medal-1.webp" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								4.5 on 5 as Personalization and Marketing Automation Platform
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/08/getapp.svg" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Top rated Marketing Automation suite for enterprises
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/08/capterra.svg" alt="gartner">
							</div> 
						</div>
					</div>
					<div class="reviews-content-list">
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Netcore is compliant with AICPA SOC 2
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/11/soc2-logo.webp" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Netcore is compliant with ISO 27001:2013
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/11/iso-2013.webp" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Netcore is compliant with ISO 9001:2015
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/11/iso-2015.webp" alt="gartner">
							</div> 
						</div>
						<div class="reviews-content">
							<div class="reviews-content-text"> 
								Netcore is compliant with GDPR
							</div> 
							<div class="reviews-content-image">
								<img src="https://netcorecloud.com/wp-content/uploads/2022/11/gdpr.webp" alt="gartner">
							</div> 
						</div>
					</div>
				</div>
				<div class="dark-footer-section">
					<div class="container">
						<div class="validation-content-list">
							<div class="validation-brands-validation">
								<div class="brands-validation validation-content">
									<div class="main-value">6,500+</div>
									<div class="main-type">Brands</div>
								</div>
								<div class="emails-sent-validation validation-content">
									<div class="main-value">25 years+</div>
									<div class="main-type">In Business</div>
								</div>
							</div>
							<div class="others-validation validation-content">
								<div class="main-type has-text-white">
									Built for scale, with a focus on revenue-impact through customer experiences, for hypergrowth brands. 
								</div>
							</div>
						</div>
						<div class="netcore-address">
							<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/netcore-logo-main.svg"/>
							<p class="">
								500 7th Avenue<br/>
								New York<br/>
								NY 10018<br/>
								<span> <img src="../assets/img/tutorial/call.svg"/> +1-5768-43930</span><br/>
								<span> <img src="../assets/img/tutorial/email.svg"/> sales@netcorecloud.com</span>
							</p>
							<p class="">
								India <br/>
								500 7th Avenue<br/>
								New York<br/>
								NY 10018<br/>
								<span> <img src="../assets/img/tutorial/call.svg"/> +1-5768-43930</span><br/>
								<span> <img src="../assets/img/tutorial/email.svg"/> sales@netcorecloud.com</span>
							</p>
						</div>
						<div class="links-content">
							<div class="links-section">
								<div class="single-link header">Company</div>
								<a class="single-link" href="//netcorecloud.com/about-us?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">About Us</a>
								<a class="single-link" href="//netcorecloud.com/leadership?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Leadership</a>
								<a class="single-link" href="//netcorecloud.com/partners?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Partners</a>
								<a class="single-link" href="//netcorecloud.com/newsroom?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Newsroom</a>
								<a class="single-link" href="//netcorecloud.com/press-releases?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Press Releases</a>
								<a class="single-link" href="//netcorecloud.com/careers?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Careers</a>
								<a class="single-link" href="//netcorecloud.com/contact-us?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" data-factors-click-bind="true">Contact Us</a>
							</div>
							<div class="links-section">
								<div class="single-link header">Products</div>
								<a class="single-link" href="//netcorecloud.com/customer-engagement/" data-factors-click-bind="true">Customer Engagement</a>
								<a class="single-link" href="//netcorecloud.com/product-experience/" data-factors-click-bind="true">Product Experience</a>
								<a class="single-link" href="//netcorecloud.com/email/" data-factors-click-bind="true">Email</a>
								<a class="single-link" href="//netcorecloud.com/amp/" data-factors-click-bind="true">AMP Email</a>
								<a class="single-link" href="//netcorecloud.com/customer-data-platform/" data-factors-click-bind="true">Customer Data Platform</a>
								<a class="single-link" href="//netcorecloud.com/personalization/" data-factors-click-bind="true">Personalization</a>
								<a class="single-link" href="//netcorecloud.com/raman-ai-engine/" data-factors-click-bind="true">Raman AI Engine </a>
							</div>
							<div class="links-section">
								<div class="single-link header">Industries</div>
								<a class="single-link" href="//netcorecloud.com/industries/e-commerce-online-retail/" data-factors-click-bind="true">E-Commerce &amp; Retail</a>
								<a class="single-link" href="//netcorecloud.com/industries/ott/" data-factors-click-bind="true">Media &amp; Entertainment</a>
								<a class="single-link" href="//netcorecloud.com/industries/travel/" data-factors-click-bind="true">Travel &amp; Hospitality</a>
								<a class="single-link" href="//netcorecloud.com/industries/edtech/" data-factors-click-bind="true">Edtech</a>
								<a class="single-link" href="//netcorecloud.com/industries/fantasy-gaming/" data-factors-click-bind="true">Fantasy Gaming</a>
								<a class="single-link" href="//netcorecloud.com/industries/business-and-financial-services/" data-factors-click-bind="true">Business &amp; Financial</a>
								<a class="single-link" href="//netcorecloud.com/industries/direct-to-consumer/" data-factors-click-bind="true">Direct to consumer</a>
								<a class="single-link" href="//netcorecloud.com/startups/india/apps/" data-factors-click-bind="true">Startup</a>
								<!-- <a class="single-link" href="//netcorecloud.com/industries/ott/" data-factors-click-bind="true">OTT Platforms</a> -->
							</div>
							<div class="links-section">
								<div class="single-link header">Services</div>
								<a class="single-link" href="//netcorecloud.com/email-consultancy/" data-factors-click-bind="true">Email Deliverability</a>
								<a class="single-link" href="//netcorecloud.com/gamechanger/" data-factors-click-bind="true">Gamechangers</a>
								<a class="single-link" href="//netcorecloud.com/mail-infrastructure/" data-factors-click-bind="true">Infrastructure &amp; Security</a>
							</div>
							<div class="links-section links-section-mobile">
								<div class="single-link header">Resource</div>
									<a class="single-link" href="//netcorecloud.com/blog/" data-factors-click-bind="true">Blog</a>
									<a class="single-link" href="//netcorecloud.com/resources/success-story/" data-factors-click-bind="true">Success stories</a>
									<a class="single-link" href="//netcorecloud.com/resources/ebook/" data-factors-click-bind="true">Ebooks</a>
									<a class="single-link" href="//netcorecloud.com/events-overview/" data-factors-click-bind="true">Events</a>
									<a class="single-link" href="//netcorecloud.com/resources/podcasts/" data-factors-click-bind="true">Podcasts</a>
									<a class="single-link" href="//netcorecloud.com/resources/webinars/" data-factors-click-bind="true">Webinars</a>
									<a class="single-link" href="//netcorecloud.com/resources/videos/" data-factors-click-bind="true">Videos</a>
									<a class="single-link" href="//netcorecloud.com/resources/guides/" data-factors-click-bind="true">Guides</a>
									<a class="single-link" href="//netcorecloud.com/tools/" data-factors-click-bind="true">Tools</a>
									<a class="single-link" target="_blank" href="https://design.netcorecloud.com/" data-factors-click-bind="true">Netcore Design</a>
							</div>
							<div class="links-section links-section-mobile">
								<div class="single-link header">Get Support</div>
								<a class="single-link" target="_blank" href="https://docs.netcoresmartech.com/" data-factors-click-bind="true">Documentation</a>
								<a class="single-link" target="_blank" href="https://netcorecloud.com/tutorials/" data-factors-click-bind="true">Email API Tutorial</a>
								<a class="single-link" target="_blank" href="https://netcore.freshdesk.com/support/home" data-factors-click-bind="true">Raise a ticket</a>
							</div>
						</div>
						<div class="footer-social-network">
							<div class="contact-details">
								<a class="footer-logo" href="/">
									<img src="https://netcorecloud.com/wp-content/uploads/2023/04/netcore-lockup-on-ash-rgb-570px-at-72ppi.webp">
								</a>
							</div>
							<div class="contact-details">
								<!-- <div class="vcenter contact-details">
									<div class="email-details">
										<img src="../assets/img/tutorial/call.svg">
										<a href="phone:+1-5768-43930">+1-5768-43930</a>
									</div>
								</div>
								<div class="vcenter contact-details">
									<div class="email-details">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/email-icon.svg">
										<a href="mailto:hello@netcorecloud.com">engage@netcorecloud.com</a>
									</div>
								</div> -->
								<div class="footer-small-links">
									<a href="https://twitter.com/netcore_cloud">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/twitter.svg">
									</a>
									<a href="https://www.linkedin.com/company/netcore-cloud/">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/linkedin.svg">
									</a>
									<a href="https://www.facebook.com/NetcoreCloud">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/facebook.svg">
									</a>
									<a href="https://www.youtube.com/user/netCORESolutions">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/youtube.svg">
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  		<!-- <div class="container">
	  		<div class="columns has-text-centered-desktop">
				<div class="column is-two-thirds has-text-left-desktop"><p>Copyright {{ new Date().getFullYear() }}, Netcore Solutions Pvt. Ltd.</p>
				</div>
				<div class="column has-text-right-desktop"><a style="color: #4a4a4a;" href="https://netcorecloud.com?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail">About Netcore </a><span style="color: #4a4a4a;">|</span><a style="color: #4a4a4a;" href="https://netcorecloud.com/privacy-policy?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail"> Privacy Policy</a> <span style="color: #4a4a4a;"> | </span> <a href="https://netcorecloud.com/gdpr?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail"><span style="color: #4a4a4a;">GDPR</span></a></div>
			</div>
			<div class="columns company-info">
				<div class="column contact-details">
					<a class="footer-logo" href="/">
						<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/netcore-logo-main.svg">
					</a>
				</div>
				<div class="column vcenter contact-details">
					<div class="email-details">
						<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/email-icon.svg">
						<a href="mailto:hello@netcorecloud.com">hello@netcorecloud.com</a>
					</div>
				</div>
				<div class="column contact-details">
					<div class="footer-small-links">
						<a href="https://twitter.com/netcore_cloud">
							<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/twitter.svg">
						</a>
						<a href="https://www.linkedin.com/company/netcore-cloud/">
							<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/linkedin.svg">
						</a>
						<a href="https://www.facebook.com/NetcoreCloud">
							<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/facebook.svg">
						</a>
						<a href="https://www.youtube.com/user/netCORESolutions">
							<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home/youtube.svg">
						</a>
					</div>
				</div>
			</div>
  		</div> -->
  	</footer>
  	<div class="copyright-row">
  		<div class="copyright-content">
  			<div class="copyright-row-text columns">
  				<div class="column is-6">
  					Copyright {{ new Date().getFullYear() }}, Netcore Cloud Pvt. Ltd.
  				</div>
				<div class="copyright-policy-gdpr">
					<a class="column text-left dotted-link" href="https://netcorecloud.com/privacy-policy?utm_source=Tutorials" target="_blank">Privacy Policy</a>
					<a class="column text-left dotted-link" href="https://netcorecloud.com/email-api-terms-and-policies/?utm_source=Tutorials" target="_blank">Email API Terms and Policies</a>
					<a class="column text-left dotted-link" href="https://netcorecloud.com/gdpr?utm_source=Tutorials" target="_blank">GDPR</a>
					<a class="column text-left dotted-link" href="https://netcorecloud.com/security/?utm_source=Tutorials" target="_blank">Data Security</a>
					<!-- <a class="column text-right dotted-link" href="https://netcorecloud.com/security?utm_source=GradeMyEmail&utm_medium=GradeMyEmail&utm_campaign=GradeMyEmail" target="_blank">Data Security</a> -->
				</div>
				<div class="column is-6 termes-condition-mobile">
					Terms and Conditions
				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
	export default {
		name: 'FooterPrismic'
	}
</script>

<style scoped>
	@import '../assets/css/tutorial/footer.css';
</style>
